import { useMutation } from "@tanstack/react-query"
import { useCallback, useState } from "react"
import customerApis from "src/api/customer"
import { AUTHEN_ID } from "src/constants/queryKeys"
import {
  ApiResponseModel,
  AuthenIdModel,
  AuthenIdRequestModel,
} from "src/types"

const useGetAuthenId = () => {
  const [data, setData] = useState<AuthenIdModel | undefined>(undefined)

  const { mutateAsync, isPending } = useMutation({
    mutationKey: [AUTHEN_ID],
    mutationFn: (payload: AuthenIdRequestModel) =>
      customerApis.getAuthenId(payload),
    onSuccess: (d: ApiResponseModel<AuthenIdModel>) => {
      setData(d?.result)
    },
  })

  const onGetAuthenId = useCallback(
    (phone: string) => {
      return mutateAsync({
        customerPhone: phone,
      })
    },
    [mutateAsync]
  )

  return { onGetAuthenId, isPending, authenIdData: data }
}

export default useGetAuthenId
